module.exports = "/images/cog.svg?071d90a6688cf44500525976f4018c84";